import React, { useEffect, useState } from 'react'
import axiosInstance from '../axios/axios';
import { useTranslate } from '../components/TranslationText';
import BigLoader from '../components/BigLoader';
import Loader from '../components/Loader';
import { includes } from 'lodash';
import CustomSlider from '../components/customSlider/customSlider';
import JudgeCard from '../components/JudgeCard';
import { noDataCard } from '../common/cssclasses';

export default function JudgesPage() {
    const baseURL = process.env.REACT_APP_BASE_URL;
    const { translate } = useTranslate();
    const [activTab, setActivTab] = useState(1);
    const [loaded, setLoaded] = useState(false);
    const [categories, setCategories] = useState([]);
    const [judges, setJudges] = useState([]);
    const tabsClasses = "col-lg-3 col-md-4 col-sm-6 col-8 my-2 text-center px-0";


    async function getCategories() {
        try {
            const response = await axiosInstance.get('/lookup/getjudgecategories');
            setCategories(response?.data?.result ?? []);
            console.log(response.data);
        } catch (error) {
            console.error(error);
        }
    }

    async function getJudges() {
        try {
            const res = await axiosInstance.get('/shows/geteahsjudges');
            setJudges(res?.data?.result ?? []);
            console.log(res?.data?.result);

            setLoaded(true);
        } catch (error) {
            console.log(error);
            setLoaded(true);
        }

    }

    useEffect(() => {
        getCategories();
        getJudges();
    }, []);




    if (!loaded) {
        return <Loader />
    }

    return (
        < >
            <>
                <CustomSlider
                    type='judges'
                    activTab={activTab}
                    categories={categories}
                    tabsClasses={tabsClasses}
                    setActivTab={setActivTab}
                />
            </>
            <div className='row rtl' >

                {judges.filter((x) => x?.judgeCategoryId?.includes(activTab?.toString())).map((judge, index) => (
                    <div className='col-lg-3 col-md-4 col-sm-6 col-12 mb-3'>
                        <JudgeCard judge={judge} />
                    </div>
                ))}

            </div>
                {judges.filter((x) => x?.judgeCategoryId?.includes(activTab?.toString())).length == 0 &&
                    <div className={noDataCard}>
                        <h4 className='text-danger text-center'>{translate('web.noDataFound', 'No Data')}</h4>
                    </div>}

        </>
    )
}
